import { NoOperation } from '@lemon8/web-app-shared/util';

const polyfills = [
    (async () => {
        if (!('ResizeObserver' in window)) {
            if (__BUILD_TYPE__ !== 'online') {
                console.log('[Polyfill]: ResizeObserver');
            }
            const { install } = await import('resize-observer');
            install();
        }
    })(),
    (async () => {
        if (!('IntersectionObserver' in window)) {
            if (__BUILD_TYPE__ !== 'online') {
                console.log('[Polyfill]: IntersectionObserver');
            }
            await import('intersection-observer');
        }
    })(),
];
const polyfill = () => {
    return Promise.all(polyfills).then(NoOperation);
};

export { polyfill };
//# sourceMappingURL=index.js.map
